"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (frame) {
    virtual.send('getTimerList');
    // 子设备设备完成登录
    virtual.emit('reportSubDevInfoResp', virtual, frame);
}; });



// WEBPACK FOOTER //
// ./src/actions/receive/actions/reportSubDevInfoResp.ts